module.exports = __webpack_public_path__ + "static/img/tooltip-solar-panel-deployable-rotating.4d50f9c.png";